module.exports = __webpack_public_path__ + "static/media/circular-bold.fc45c938.ttf";